import loadDiagnosticLabelsPreview from "./load-diagnostic-label-preview.js";

loadDiagnosticLabelsPreview()
